import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderProgresiveChristianity from "../../../../src/content/nn-progressive-christianity-sign-up/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderProgresiveChristianity,
  React
};